import { useQuery } from "@tanstack/react-query";
import { BRAND_PERMISSIONS_QUERY_KEY } from "../constants";
import { PoliciesService } from "../services/policies.service";

export const useGetBrandPermissions = () => {
  const {
    data: brandPermissions,
    isFetching: isFetchingBrandPermissions,
    error: brandPermissionsError,
    isSuccess: isSuccessBrandPermissions,
  } = useQuery({
    queryKey: [...BRAND_PERMISSIONS_QUERY_KEY],
    queryFn: () => PoliciesService.getBrandPermissions(),
  });
  return {
    brandPermissions,
    isFetchingBrandPermissions,
    brandPermissionsError,
    isSuccessBrandPermissions,
  };
};
